/**
 * Possible views for calendar -> list view can be added if necessary.
 */
export var CalendarView;
(function (CalendarView) {
    CalendarView["Daily"] = "timeGridDay";
    CalendarView["Weekly"] = "timeGridWeek";
    CalendarView["Monthly"] = "dayGridMonth";
})(CalendarView || (CalendarView = {}));
